__webpack_require__.p = "/mah-gdpr-automations-39jbbcr/referrals-hub/";